/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["jquery", "underscore", "backbone", "service/channel", "service/messageframes"], function($, _, Backbone, Channel, MessageFrames) {

    // reads from the input and triggers the following events on the output
    // 
    var MessageFrameChannel = Channel.extend({

        initialize: function () {
          Channel.prototype.initialize.apply(this, arguments);

          var messageFrames = this.get("messageFrames"),
              url = this.get("url"),
              that = this;

          this.messageFrame = messageFrames.forURL(url, this.options);
          if (!this.messageFrame.get("enabled")) {
            this.set("enabled", false);
          }
          this.messageFrame.on("change:enabled", function (messageFrame, enabled) {
            if (!enabled) {
              that.set("enabled", false);
            }
          });

          this.listenTo(this, "add", this.enableIdp);
          this.listenTo(this, "change:enabled", this.enableIdp);
        },

        enableIdp: function () {
          if (this.get("enabled")) {
            var messageFrames = this.get("messageFrames");
            messageFrames.enableIdpOfChannel(this);
          }
        },

        clone: function () {
          var clone = Channel.prototype.clone.apply(this, arguments);
          clone.set("enabled", this.get("enabled"));
          return clone;
        },

        internalCall: function(path, request, responseObserver, formatOptions, headers, options, requestCount, promise) {
          options = options || {};

          var promise = promise || this.createDeferredCallFinishedPromise(this, options);

          var dataType = "json";
          if (formatOptions && formatOptions.dataType) dataType = formatOptions.dataType;

          var url = this.get("url") + (path || "");
          var call = new MessageFrames.Call(url, dataType === "json" ? JSON.stringify(request) : request, options.method || this.get("method"), "text", headers, formatOptions);
          call.on("response", function(data, url){
              if (dataType === "json" && !_.isObject(data)) {
                try {
                  data = JSON.parse(data);
                } catch (e) {
                  var error = {status: 200, url: url, message: "Could not parse JSON.", error: e}
                  this.error(error, promise, responseObserver);
                }
              }
              this.success(data, promise, responseObserver, options);
            }, this);
          call.on("error", function(error) {
              error.path = path;
              this.error(error, promise, responseObserver);
            }, this);
          
          try {
            this.messageFrame.perform(call);      
          } catch(e) {
            var error = {status: 500, url: url, message: "Caught exception performing messageFrame call", error: e , path: path}
            this.error(error, promise, responseObserver);
          }

          return promise;
        }
    });

    return MessageFrameChannel;
});

